import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { AppShell } from '@/components/AppShell';
import { PwaUpdater } from '@/components/PwaUpdater';
import { AppRouter } from '@/routes/AppRouter';
import { useAuth } from '@/providers/AuthProvider';
import IntroPage from '@/features/intro/pages/IntroPage';
import { LocationGate } from '@/features/location/LocationGate';

const App = () => {
  const { isAuthenticated, isLoading, login } = useAuth();

  if (!isAuthenticated) {
    return (
      <>
        <PwaUpdater />
        <IntroPage onLogin={login} isLoading={isLoading} />
      </>
    );
  }

  return (
    <>
      <PwaUpdater />
      <LocationGate>
        <AppShell>
          <AppRouter />
          <ReactQueryDevtools
            initialIsOpen={false}
            buttonPosition="bottom-right"
            position="bottom"
          />
        </AppShell>
      </LocationGate>
    </>
  );
};

export default App;
